"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Registrants_1 = __importDefault(require("./Registrants"));
class Index {
    constructor(parent, sessionId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.sessionId = sessionId;
    }
    path(withParameter = true) {
        if (withParameter && this.sessionId !== null) {
            return `${this.parent.path()}/sessions/${this.sessionId}`;
        }
        return `${this.parent.path()}/sessions`;
    }
    /**
     * Returns a registration Session information by ID.
   *
   * A caller must be an authorized user: either a host of the webinar or an IT Admin:
   * a user from host's account with "WebinarSettings" permission.
   *
     * HTTP Method: get
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async get(restRequestConfig) {
        if (this.sessionId === null) {
            throw new Error('sessionId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a Session by ID.
   *
   * This is a PARTIAL update (PATCH), client may call it providing only attributes which are to be changed.
   *
   * A caller must be an authorized user: either a host of the webinar or an IT Admin:
   * a user from host's account with "WebinarSettings" permission.
   *
   * If a session record with given ID doesn't exist on Registration Service side the API should return HTTP 404.
   *
     * HTTP Method: patch
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */
    async patch(regSessionModel, restRequestConfig) {
        if (this.sessionId === null) {
            throw new Error('sessionId must be specified.');
        }
        const r = await this.rc.patch(this.path(), regSessionModel, undefined, restRequestConfig);
        return r.data;
    }
    registrants(registrantId = null) {
        return new Registrants_1.default(this, registrantId);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map